import { Translate } from 'react-redux-i18n'
import TooltipExpression from '../../common/tooltipExpression'

export const TREND_CHARTS = [
  {
    value: 'RT0044',
    color: '#006AA6',
    tooltipContent: (
      <TooltipExpression
        expressions={[
          {
            text: <Translate value="financialAnalysis.INTEREST_COVERAGE_1" />,
            operator: '=',
          },
          {
            text: 'EBIT',
            isDivide: true,
            textUnder: (
              <Translate value="financialAnalysis.INTEREST_COVERAGE_2" />
            ),
          },
        ]}
      />
    ),
  },
  {
    value: 'RT0045',
    color: '#F49966',
    tooltipContent: (
      <TooltipExpression
        expressions={[
          {
            text: <Translate value="financialAnalysis.ASSET_COVERAGE_1" />,
            operator: '=',
          },
          {
            text: (
              <>
                (<Translate value="financialAnalysis.ASSET_COVERAGE_2" /> -{' '}
                <Translate value="financialAnalysis.ASSET_COVERAGE_3" />) -
                <br />
                (<Translate value="financialAnalysis.ASSET_COVERAGE_4" /> -{' '}
                <Translate value="financialAnalysis.ASSET_COVERAGE_5" />)
              </>
            ),
            isDivide: true,
            textUnder: <Translate value="financialAnalysis.ASSET_COVERAGE_6" />,
          },
        ]}
      />
    ),
  },
  {
    value: 'RT0046',
    color: '#00A8B5',
    tooltipContent: (
      <TooltipExpression
        expressions={[
          {
            text: <Translate value="financialAnalysis.EBITDA_COVERAGE_1" />,
            operator: '=',
          },
          {
            text: 'EBITDA',
            isDivide: true,
            textUnder: (
              <Translate value="financialAnalysis.EBITDA_COVERAGE_2" />
            ),
          },
        ]}
      />
    ),
  },
  {
    value: 'RT0047',
    color: '#FF596A',
    tooltipContent: (
      <TooltipExpression
        expressions={[
          {
            text: <Translate value="financialAnalysis.CASH_COVERAGE_1" />,
            operator: '=',
          },
          {
            text: <Translate value="financialAnalysis.CASH_COVERAGE_2" />,
            isDivide: true,
            textUnder: <Translate value="financialAnalysis.CASH_COVERAGE_3" />,
          },
        ]}
      />
    ),
  },
]
